/**
 * Find the first key in the inputKeys that has a dependency on the targetKey.
 *
 * If `findTargetDependency(targetKey, inputKeys, dependencyGraph)` returns undefined, then
 * it is safe to call `dependencyGraph.set(targeyKey, inputKeys)` without adding a circular reference.
 *
 * If `findTargetDependency(targetKey, inputKeys, dependencyGraph)` returns a key, then adding the dependency
 * is an error which would create a circular reference (ie. an endless evaluation loop).
 *
 * @param targetKey the key to search for
 * @param inputKeys the immediate input keys on which the target depends.
 * @param dependencyGraph the graph of existing dependencies
 * @returns the key of the first input which already depends on the target, or undefined no dependencies exist.
 */
export function findTargetDependency<T>(
  targetKey: T,
  inputKeys: T[],
  dependencyGraph: Map<T, T[]>,
): T | undefined {
  return inputKeys.find(
    (key) =>
      targetKey === key ||
      findTargetDependency(targetKey, dependencyGraph.get(key) || [], dependencyGraph),
  );
}
